<template>
  <div id="particles-js"></div>
</template>

<script>
export default {
  name: "particlesJS",

  mounted() {
    require("particles.js");
    this.$nextTick(() => {
      this.initParticlesJS();
    });
  },

  methods: {
    initParticlesJS() {
      /* eslint-disable */
      /* ---- particles.js config ---- */

      // particlesJS("particles-js", {
      //   particles: {
      //     number: {
      //       value: 355,
      //       density: {
      //         enable: true,
      //         value_area: 789.1476416322727
      //       }
      //     },
      //     color: {
      //       value: "#7E57C2"
      //     },
      //     shape: {
      //       type: "circle",
      //       stroke: {
      //         width: 2,
      //         color: "#7E57C2"
      //       },
      //       polygon: {
      //         nb_sides: 5
      //       },
      //       image: {
      //         src: "img/github.svg",
      //         width: 100,
      //         height: 100
      //       }
      //     },
      //     opacity: {
      //       value: 0.48927153781200905,
      //       random: false,
      //       anim: {
      //         enable: true,
      //         speed: 0.2,
      //         opacity_min: 0,
      //         sync: false
      //       }
      //     },
      //     size: {
      //       value: 4,
      //       random: true,
      //       anim: {
      //         enable: true,
      //         speed: 2,
      //         size_min: 0,
      //         sync: false
      //       }
      //     },
      //     line_linked: {
      //       enable: false,
      //       distance: 150,
      //       color: "#7E57C2",
      //       opacity: 0.4,
      //       width: 1
      //     },
      //     move: {
      //       enable: true,
      //       speed: 2,
      //       direction: "none",
      //       random: true,
      //       straight: false,
      //       out_mode: "out",
      //       bounce: false,
      //       attract: {
      //         enable: false,
      //         rotateX: 600,
      //         rotateY: 1200
      //       }
      //     }
      //   },
      //   interactivity: {
      //     detect_on: "canvas",
      //     events: {
      //       onhover: {
      //         enable: true,
      //         mode: "bubble"
      //       },
      //       onclick: {
      //         enable: true,
      //         mode: "push"
      //       },
      //       resize: true
      //     },
      //     modes: {
      //       grab: {
      //         distance: 400,
      //         line_linked: {
      //           opacity: 1
      //         }
      //       },
      //       bubble: {
      //         distance: 83.91608391608392,
      //         size: 5,
      //         duration: 5,
      //         opacity: 1,
      //         speed: 100
      //       },
      //       repulse: {
      //         distance: 200,
      //         duration: 0.1
      //       },
      //       push: {
      //         particles_nb: 10
      //       },
      //       remove: {
      //         particles_nb: 2
      //       }
      //     }
      //   },
      //   retina_detect: true
      // });

      // ParticlesJS Config.
      // ParticlesJS Config.
      particlesJS("particles-js", {
        particles: {
          number: { value: 10, density: { enable: false, value_area: 800 } },
          color: { value: "#7a7a7d" },
          shape: {
            type: "edge",
            stroke: { width: 0, color: "#000" },
            polygon: { nb_sides: 6 },
            image: { src: "img/github.svg", width: 100, height: 100 }
          },
          opacity: {
            value: 0.3,
            random: true,
            anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false }
          },
          size: {
            value: 160,
            random: false,
            anim: { enable: true, speed: 10, size_min: 30, sync: false }
          },
          line_linked: {
            enable: false,
            distance: 200,
            color: "#ffffff",
            opacity: 1,
            width: 2
          },
          move: {
            enable: true,
            speed: 5.2,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: { enable: true, rotateX: 600, rotateY: 1200 }
          }
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: false, mode: "bubble" },
            onclick: { enable: false, mode: "repulse" },
            resize: true
          },
          modes: {
            grab: { distance: 400, line_linked: { opacity: 1 } },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3
            },
            repulse: { distance: 200, duration: 0.4 },
            push: { particles_nb: 4 },
            remove: { particles_nb: 2 }
          }
        },
        retina_detect: true
      });
      var count_particles, stats, update;
      stats = new Stats();
      stats.setMode(0);
      stats.domElement.style.position = "absolute";
      stats.domElement.style.left = "0px";
      stats.domElement.style.top = "0px";
      document.body.appendChild(stats.domElement);
      count_particles = document.querySelector(".js-count-particles");
      update = function() {
        stats.begin();
        stats.end();
        if (
          window.pJSDom[0].pJS.particles &&
          window.pJSDom[0].pJS.particles.array
        ) {
          count_particles.innerText =
            window.pJSDom[0].pJS.particles.array.length;
        }
        requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
      /* ---- stats.js config ---- */

      // var count_particles, stats, update;
      // stats = new Stats();
      // stats.setMode(0);
      // stats.domElement.style.position = "absolute";
      // stats.domElement.style.left = "0px";
      // stats.domElement.style.top = "0px";
      // document.body.appendChild(stats.domElement);
      // count_particles = document.querySelector(".js-count-particles");
      // update = function() {
      //   stats.begin();
      //   stats.end();
      //   if (
      //     window.pJSDom[0].pJS.particles &&
      //     window.pJSDom[0].pJS.particles.array
      //   ) {
      //     count_particles.innerText =
      //       window.pJSDom[0].pJS.particles.array.length;
      //   }
      //   requestAnimationFrame(update);
      // };
      // requestAnimationFrame(update);
    }
  }
};
</script>

<style scoped>
/* Your styles */
#particles-js {
  position: fixed;

  width: 100%;
  height: 100vh;
  left: 0;
  z-index: -99;
}
body,
html {
  height: 100vh;
}
</style>